import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {BUTTON_STYLE, BUTTON_COLOR} from '../../constants';
import Button from '../../forecast-app/shared/components/buttons/button/button';
import {injectIntl} from 'react-intl';
import PlanCardSVG from '../../images/v2/components/plan_card.svg';
import DeactivateJiraServerMutation from '../../mutations/deactivate_jira_server_mutation';
import DeactivateJiraCloudMutation from '../../mutations/deactivate_jira_cloud_mutation';
import Util from '../../forecast-app/shared/util/util';
import Warning from '../warning';
import {MODAL_TYPE, showModal} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import ForecastTooltip from '../../forecast-app/shared/components/tooltips/ForecastTooltip';
import InformationIcon from '../../images/information-icon';

class PlanCard extends Component {
	deactivateJira() {
		showModal({
			type: MODAL_TYPE.GENERIC,
			content: (
				<div>
					<Warning messageId={this.props.jiraCloudEnabled ? 'settings.app_catalog.jira_cloud.deactivate' : 'settings.app_catalog.jira_server.deactivate'} />
					<div className="warning-part-2">{this.props.intl.formatMessage({id: 'common.warning.this_action_can_not_be_undone'})}</div>
				</div>
			),
			className: 'default-warning-modal',
			buttons: [
				{
					text: this.props.intl.formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
				{
					text: this.props.intl.formatMessage({id: 'common.deactivate'}),
					callback: () => {
						Util.CommitMutation(this.props.jiraCloudEnabled ? DeactivateJiraCloudMutation : DeactivateJiraServerMutation);
					},
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.RED,
				},
			],
		});
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className={'plan-card' + (this.props.selected ? ' selected' : '')} onClick={this.props.onClick}>
				<object type="image/svg+xml" data={PlanCardSVG} className="background-svg" />
				<div className={'plan-card-contents'}>
					<div className={'plan-card-top-section'}>
						<div className={'plan-header-title'}>{this.props.title}</div>
						<div className={'plan-header-subtitle'}>{this.props.subTitle}</div>
						<div className={'pricing-section'}>
							<div className={'plan-price'}>{this.props.priceText}</div>
							<div className={'plan-period-and-unit'}>
								{this.props.unit}/{this.props.period}
							</div>
							<div className={'pricing-info-wrapper'}>
								<div className={'pricing-additional-info'}>{this.props.additionalInfo}</div>
								<ForecastTooltip content={formatMessage({id: 'settings_people.virtual_description'})}>
									<InformationIcon />
								</ForecastTooltip>
							</div>
						</div>
						<div className={'plan-min-count'}>{this.props.minCountText}</div>
						{this.props.jiraCloudEnabled || this.props.jiraServerEnabled ? (
							<div className="jira-warning">
								{formatMessage({id: 'select_plan.jira-error-message'})}
								<br />
								<Button className={'deactivate-jira-button'} onClick={() => this.deactivateJira()} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.RED} text={formatMessage({id: 'settings.app_catalog.jira.deactivate'})} />
							</div>
						) : (
							''
						)}
						<Button
							className={'select-plan-button'}
							onClick={this.props.onButtonClick}
							buttonStyle={BUTTON_STYLE.FILLED}
							colorTheme={BUTTON_COLOR.GREEN}
							text={this.props.buttonText}
							cy={'select-plan-button'}
							isDisabled={this.props.jiraCloudEnabled || this.props.jiraServerEnabled}
						/>
					</div>
					<div className={'plan-card-triangle-section'}>
						{this.props.savingsTitle || this.props.savingsText ? (
							<div className={'savings-info'}>
								<div className={'savings-title'}>{this.props.savingsTitle}</div>
								<div className={'savings-text'}>{this.props.savingsText}</div>
							</div>
						) : null}
					</div>
				</div>
				{this.props.perkListExpanded ? (
					<div className={'plan-card-bottom-list animated fadeInDown'}>
						<div className={'plan-card-bottom-spacer'} />
						<div className={'plan-card-list-header'}>{this.props.perkListHeader}</div>
						{this.props.perksList.map((perk, index) => (
							<div key={index} className={'plan-perk'}>
								{perk.label ? <div className={'purple-hexagon'} /> : null}
								<div className={'plan-label'}>{perk.label}</div>
							</div>
						))}
					</div>
				) : null}
			</div>
		);
	}
}
PlanCard.propTypes = {
	onClick: PropTypes.func,
	onButtonClick: PropTypes.func.isRequired,
	selected: PropTypes.bool,
	title: PropTypes.string.isRequired,
	subTitle: PropTypes.string,
	priceText: PropTypes.string,
	period: PropTypes.string,
	unit: PropTypes.string,
	additionalInfo: PropTypes.string,
	minCountText: PropTypes.string,
	savingsTitle: PropTypes.string,
	savingsText: PropTypes.string,
	perksList: PropTypes.array.isRequired,
	perkListHeader: PropTypes.string,
	jiraCloudEnabled: PropTypes.bool,
	jiraServerEnabled: PropTypes.bool,
};
export default injectIntl(PlanCard);
